import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="post-medium-favorited"
export default class extends Controller {
    static targets = ["solidIcon", "outlineIcon"]
    static values = { id: Number, favorited: Boolean, removeOnUnfavorite: Boolean }

    toggle() {
        const nextFavorited = !this.favoritedValue
        const csrfToken = document.querySelector("[name='csrf-token']").content

        fetch(`/media/${this.idValue}/favorited`, {
            method: "POST",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken
            },
            body: JSON.stringify({ favorited: nextFavorited })
        }).then(response => {
            if (!response.ok) throw new Error(`Favorited update failed: ${response.status}`)

            if (!nextFavorited && this.removeOnUnfavoriteValue) {
                this.element.closest(".group").remove()
                return
            }

            this.favoritedValue = nextFavorited
            this.element.setAttribute("aria-label", nextFavorited ? "Unfavorite media" : "Favorite media")
            this.element.classList.toggle("opacity-100", nextFavorited)
            this.element.classList.toggle("opacity-0", !nextFavorited)
            this.solidIconTarget.classList.toggle("hidden", !nextFavorited)
            this.outlineIconTarget.classList.toggle("hidden", nextFavorited)
        }).catch(() => {
            window.toast("Couldn't update media favorite. Please try again.", { kind: "alert" })
        })
    }
}
